export default "__VITE_ASSET__$yv54euk__"